import { render } from "./AppSocials.vue?vue&type=template&id=2dd5b001&scoped=true"
import script from "./AppSocials.vue?vue&type=script&lang=js"
export * from "./AppSocials.vue?vue&type=script&lang=js"

import "./AppSocials.vue?vue&type=style&index=0&id=2dd5b001&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd5b001"]])

export default __exports__